var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4574 2.63573H11.9924C11.8198 1.15455 10.5444 0 9.00011 0C7.4558 0 6.18065 1.15433 6.0078 2.63573H2.54281C1.14069 2.63573 0 3.76335 0 5.14912V5.27798C0 6.3369 0.667104 7.24339 1.607 7.6129L2.74269 19.4864C2.74269 20.8724 3.8836 22 5.2855 22H12.7145C14.1166 22 15.2573 20.8724 15.2573 19.4866L16.393 7.61312C17.3329 7.24384 18 6.33735 18 5.27843V5.14957C18.0005 3.76335 16.8595 2.63573 15.4574 2.63573ZM9.00011 1.19204C9.87846 1.19204 10.6117 1.81433 10.7738 2.63573H7.22685C7.3888 1.8141 8.12223 1.19204 9.00011 1.19204ZM14.0514 19.4866C14.0514 20.2153 13.4516 20.8082 12.7145 20.8082H5.2855C4.54844 20.8082 3.94857 20.2153 3.94857 19.4866L2.81288 7.79182H15.1869L14.0514 19.4866ZM16.7944 5.2782C16.7944 6.0069 16.1945 6.59978 15.4574 6.59978H2.54281C1.80575 6.59978 1.20588 6.0069 1.20588 5.2782V5.14935C1.20588 4.42065 1.80575 3.82778 2.54281 3.82778H15.4576C16.1947 3.82778 16.7946 4.42065 16.7946 5.14935L16.7944 5.2782Z",
    fill: "#A9AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5792 18.6915C10.9118 18.7088 11.1955 18.456 11.2129 18.1276L11.6159 10.5295C11.6334 10.2009 11.3778 9.92024 11.0453 9.90318C10.7128 9.8859 10.4289 10.1384 10.4116 10.4671L10.0087 18.0652C9.99117 18.3938 10.2469 18.6744 10.5792 18.6915Z",
    fill: "#A9AEB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.41641 18.6915C7.74894 18.6742 8.00447 18.3938 7.98698 18.0652L7.58404 10.4671C7.56678 10.1384 7.28285 9.8859 6.95032 9.90318C6.61779 9.92047 6.36226 10.2009 6.37975 10.5295L6.7827 18.1276C6.80019 18.4562 7.08388 18.7088 7.41641 18.6915Z",
    fill: "#A9AEB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImg);
export default __webpack_public_path__ + "static/media/deleteImg.799498b1afc3577666a9f60bf14e563a.svg";
export { ForwardRef as ReactComponent };